import {useEffect, useState} from 'react'

const DEFAULT_DELAY = 300

const useDebouncedValue = (value, delay = DEFAULT_DELAY) => {
    const [debouncedValue, setDebouncedValue] = useState(value)

    useEffect(() => {
        if (debouncedValue === value) return

        const timeout = setTimeout(() => setDebouncedValue(value), delay)
        return () => clearTimeout(timeout)
    }, [debouncedValue, delay, value])

    return debouncedValue
}

export default useDebouncedValue
